// [src/pages/Payment/PaymentFail.jsx]

import React from 'react';
import { useLocation } from 'react-router-dom';

function PaymentFail() {
    const location = useLocation();

    // 전달받은 에러 정보
    const { code, message } = location.state || {
        code: 'UNKNOWN',
        message: '알 수 없는 오류가 발생했습니다.'
    };

    const handleGoHome = () => {
        window.location.href = "hypehaus://home";
        setTimeout(() => {
            window.location.replace('/');
        }, 500);
    };

    return (
        <div style={staticStyles.backgroundWrapper}>
            <main style={staticStyles.mainContent}>
                <div style={staticStyles.messageSection}>
                    <div style={staticStyles.iconWrapper}>
                        <div style={staticStyles.closeIcon} />
                    </div>
                    <h2 style={staticStyles.title}>결제에 실패했습니다</h2>
                    <p style={staticStyles.description}>
                        오류 코드: {code}<br/>
                        사유: {message}
                    </p>
                </div>

                <div style={staticStyles.infoBox}>
                    <p style={staticStyles.infoText}>
                        일시적인 오류일 수 있습니다.<br/>
                        잠시 후 다시 시도해 주세요.
                    </p>
                </div>
            </main>

            <div style={staticStyles.bottomButtonWrapper}>
                <button style={staticStyles.confirmButton} onClick={handleGoHome}>
                    홈으로 가기
                </button>
            </div>
        </div>
    );
}

/** @type {React.CSSProperties} */
const staticStyles = {
    backgroundWrapper: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, width: '100%', height: '100%', backgroundColor: '#0D042D', display: 'flex', flexDirection: 'column', alignItems: 'stretch', margin: '0 auto', boxSizing: 'border-box', overflow: 'hidden', zIndex: 1 },
    mainContent: { flex: 1, overflowY: 'auto', paddingTop: 'calc(env(safe-area-inset-top, 47px) + 50px)', paddingBottom: '100px', paddingLeft: '24px', paddingRight: '24px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' },
    messageSection: { display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', marginBottom: '40px' },
    iconWrapper: { width: '80px', height: '80px', borderRadius: '50%', background: 'rgba(255, 82, 82, 0.1)', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '24px' },
    closeIcon: { width: '24px', height: '24px', background: `linear-gradient(45deg, transparent 44%, #FF5252 44%, #FF5252 56%, transparent 56%), linear-gradient(-45deg, transparent 44%, #FF5252 44%, #FF5252 56%, transparent 56%)` },
    title: { fontFamily: 'Pretendard', fontWeight: '700', fontSize: '24px', color: '#FCFCFA', margin: '0 0 12px 0' },
    description: { fontFamily: 'Pretendard', fontWeight: '400', fontSize: '16px', color: '#9A9A9A', lineHeight: '1.5', margin: 0, whiteSpace: 'pre-line' },
    infoBox: { width: '100%', backgroundColor: '#1B1931', borderRadius: '10px', padding: '20px', boxSizing: 'border-box', textAlign: 'center' },
    infoText: { fontFamily: 'Pretendard', fontWeight: '500', fontSize: '14px', color: '#747474', lineHeight: '1.6', margin: 0 },
    bottomButtonWrapper: { position: 'fixed', bottom: 0, left: 0, width: '100%', padding: '24px 24px calc(env(safe-area-inset-bottom, 24px) + 24px)', boxSizing: 'border-box', backgroundColor: '#0D042D', zIndex: 100 },
    confirmButton: { width: '100%', height: '56px', border: 'none', borderRadius: '8px', background: '#3A394A', cursor: 'pointer', fontFamily: 'Pretendard', fontWeight: '700', fontSize: '16px', color: '#FFFFFF' },
};

export default PaymentFail;